import axios, { AxiosResponse } from 'axios';

import { Incident } from 'components/statusPage/types';
import { reportSentryError } from 'sentry';

export class StatusPageLoader {
  private readonly url: string;

  public data: Incident[] | Incident['status'];

  constructor(url: string) {
    this.url = url;
    this.data = [];
  }

  // eslint-disable-next-line class-methods-use-this
  protected parseResponseData(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    response: AxiosResponse
  ): Incident[] | Incident['status'] {
    return [];
  }

  // eslint-disable-next-line class-methods-use-this
  protected getFilteredIncidents(
    incidents: Incident[],
    statuses: string[]
  ): Incident[] {
    const statusComponentIds = CONFIG.statusComponentsIds;
    const filteredIncidents = incidents.filter((incident) =>
      incident.componentIds.some((id) => statusComponentIds.includes(id))
    );
    return filteredIncidents.filter((incident) =>
      statuses.includes(incident.status)
    );
  }

  async load(): Promise<Incident[] | Incident['status']> {
    try {
      await this.requestData();
      return this.data;
    } catch (error) {
      return this.handleError();
    }
  }

  async handleError(): Promise<Incident[] | Incident['status']> {
    this.data = [];
    return this.data;
  }

  async requestData(): Promise<void> {
    try {
      const response = await axios.get(this.url);
      this.data = this.parseResponseData(response);
    } catch (error) {
      reportSentryError(error, {
        level: 'error',
        extra: {
          query: 'status-page-incidents',
          endpoint: this.url
        }
      });
      console.error(`Failed to load: ${this.url}!`);
      throw error;
    }
  }
}
